<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9L12 4L21 9V18C21 19.657 19.657 21 18 21H6C4.343 21 3 19.657 3 18V9Z" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 4V12" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="12" cy="16" r="2" stroke="#00B9FF" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'IconEducation'
}
</script>
